import { ContactFormData } from '@/types/forms';
import * as yup from 'yup';
import { formRules } from '../forms.rules';

export const contactUsFormValidationSchema = yup
  .object<ContactFormData>()
  .shape({
    name: formRules.text('Name', { required: true }),
    title: formRules.text('Title', { required: true }),
    message: formRules.text('Message', { required: true }),
    email: formRules.email,
    file: formRules.file(),
    contact_form_topic_id: formRules.select({ required: true }),
  });
